import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { flex } from "shared/theme/mixins";

export const StyledBox = styled(Box)`
  ${flex()};
  padding: 0.5rem 0.75rem;
  column-gap: 0.5rem;
  background-color: rgba(255, 123, 0, 0.1);
  border-radius: 0.5rem;
`;
